import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab2 = ({ alldata ,isLoading }) => {
    if (isLoading) {
    return <p>Loading...</p>; // or show a skeleton loader
  }
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Warranty / AMC Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
          type="text"
          readOnly
            id="WarrantyExpiryDate"
            label="Warranty Expiry Date"
            style={{
              height: "38px",
             
            }}
            value={alldata?.warranty_expiry_date || ""}
           
          />
        </div>
      </div>

      <div className="col-6">
        <div className="mb-3">
          <Input
           type="text"
           readOnly
            id="AmcExpiryDate"
            style={{
              height: "38px",
             
            }}
            label="AMC Expiry Date"
            value={alldata?.amc_expiry_date || ""}
          />
        </div>
      </div>
    </div>
  );
};

export default Tab2;